@if (items().length === 0) {
  <div class="text-center p-6 text-muted-color">
    <i class="pi pi-info-circle text-2xl mb-2"></i>
    <div>Seu carrinho está vazio.</div>
  </div>
} @else {
  <div class="flex flex-col gap-4 p-4">
    @for (cartItem of items(); track cartItem.item.id) {
      <div
        class="flex items-center gap-9 border-b border-surface-200 dark:border-surface-700 pb-3 last:border-b-0"
      >
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <div
            class="w-12 h-12 bg-surface-100 dark:bg-surface-800 rounded flex items-center justify-center"
          >
            <i class="pi pi-image text-muted-color"></i>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold cart-item-name">
              {{ cartItem.item.name }}
            </div>
            <div class="text-sm text-muted-color">
              ID: {{ cartItem.item.id }}
            </div>
          </div>
        </div>
        <div class="flex items-center gap-2 flex-shrink-0">
          <p-inputNumber
            #inputQty
            [ngModel]="cartItem.quantity"
            (ngModelChange)="updateQuantity(cartItem, $event)"
            mode="decimal"
            [showButtons]="true"
            buttonLayout="horizontal"
            spinnerMode="horizontal"
            decrementButtonClass="p-button-secondary p-button-text p-button-sm"
            incrementButtonClass="p-button-secondary p-button-text p-button-sm"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            [min]="1"
            [max]="80"
            inputStyleClass="w-10 text-center"
          >
          </p-inputNumber>
          <p-button
            icon="pi pi-trash"
            styleClass="p-button-danger p-button-text p-button-rounded"
            pTooltip="Remover Item"
            tooltipPosition="top"
            (click)="removeItem(cartItem)"
          ></p-button>
        </div>
      </div>
    }
  </div>
  <div
    class="flex justify-end gap-2 p-4 border-t border-surface-200 dark:border-surface-700"
  >
    <p-button
      label="Limpar"
      severity="danger"
      [outlined]="true"
      size="small"
      (click)="cartService.clearCart()"
    ></p-button>
    <p-button
      label="Criar Reserva"
      icon="pi pi-calendar-plus"
      size="small"
      (click)="goToReservation()"
    ></p-button>
  </div>
}
